import { render, staticRenderFns } from "./ScheduleGroup.vue?vue&type=template&id=1ddf107b&scoped=true"
import script from "./ScheduleGroup.vue?vue&type=script&lang=js"
export * from "./ScheduleGroup.vue?vue&type=script&lang=js"
import style0 from "./ScheduleGroup.vue?vue&type=style&index=0&id=1ddf107b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddf107b",
  null
  
)

export default component.exports